// extracted by mini-css-extract-plugin
export default {"disabled-radio-input":"disabled-radio-input-D8Rhx"};